/**
 * ErrorData.ts
 */
export class ErrorData {
    constructor() {
        this.reset();
    }
    reset() {
        this.code = 0;
        this.acknowledged = false;
    }
    setCode(value) {
        console.trace("set error in error data");
        this.code = value;
    }
    setAcknowledged(value) {
        this.acknowledged = value;
    }
    getCode() {
        return this.code;
    }
    hasError() {
        return this.code != 0;
    }
    hasAcknowledged() {
        return this.acknowledged;
    }
}
//# sourceMappingURL=ErrorData.js.map